var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.23 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.53,40a1.34,1.34,0,0,0,1.15-.67L27.46,20.62a1.34,1.34,0,0,0,0-1.34L16.68.6a1.38,1.38,0,0,0-2.31,0L3.59,19.28a1.34,1.34,0,0,0,0,1.34L14.37,39.31A1.35,1.35,0,0,0,15.53,40Zm0-36,9.24,16L15.53,36,6.29,20Z",
    transform: "translate(-3.41 0.02)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.09,20a5.57,5.57,0,1,0-5.56,5.57A5.57,5.57,0,0,0,21.09,20Zm-8.46,0a2.9,2.9,0,1,1,2.9,2.9A2.89,2.89,0,0,1,12.63,20Z",
    transform: "translate(-3.41 0.02)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.ea93ce28452448e48848545253160e13.svg";
export { ForwardRef as ReactComponent };